require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconPen.tsx
var IconPen_exports = {};
__export(IconPen_exports, {
  default: () => IconPen_default
});
module.exports = __toCommonJS(IconPen_exports);

// src/assets/monochrome/pen.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgPen = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.34618 0.150944C2.04317 0.0776836 1.72642 0.0835219 1.42632 0.167899C1.12622 0.252277 0.852835 0.412362 0.632404 0.632793C0.411972 0.853224 0.251888 1.12661 0.16751 1.42671C0.0831328 1.72681 0.0772945 2.04356 0.150555 2.34656L0.154891 2.36376L3.20614 13.9772C3.2886 14.3104 3.46369 14.6136 3.71126 14.8516C3.96136 15.092 4.275 15.2559 4.61518 15.324L9.69233 16.3395C9.6775 16.4331 9.66992 16.5283 9.66992 16.6242C9.66992 17.1066 9.86159 17.5693 10.2026 17.9104L11.6604 19.3682C12.0015 19.7092 12.4641 19.9008 12.9464 19.9008C13.4288 19.9008 13.8915 19.7091 14.2326 19.3681L19.3667 14.234C19.7077 13.8929 19.8993 13.4303 19.8993 12.948C19.8993 12.4656 19.7076 12.0029 19.3666 11.6618L17.9088 10.204C17.5677 9.863 17.1051 9.67142 16.6227 9.67142C16.5272 9.67142 16.4325 9.67894 16.3393 9.69363L15.3236 4.61561C15.2555 4.27543 15.0916 3.96175 14.8512 3.71165C14.6132 3.46408 14.3101 3.28899 13.9768 3.20653L2.36337 0.15528L2.34618 0.150944ZM16.3118 11.7745C16.3315 11.7565 16.3503 11.7376 16.3683 11.718L16.6093 11.477C16.6128 11.4735 16.6177 11.4714 16.6227 11.4714C16.6278 11.4714 16.6327 11.4735 16.6362 11.477L18.0937 12.9345C18.0973 12.938 18.0993 12.9429 18.0993 12.948C18.0993 12.953 18.0973 12.9579 18.0937 12.9614L12.9599 18.0952C12.9564 18.0988 12.9515 18.1008 12.9464 18.1008C12.9414 18.1008 12.9365 18.0988 12.933 18.0952L11.4754 16.6377C11.4719 16.6341 11.4699 16.6293 11.4699 16.6242C11.4699 16.6192 11.472 16.6143 11.4755 16.6108L11.7176 16.3687C11.7372 16.3507 11.7561 16.3319 11.7741 16.3122L16.3118 11.7745ZM14.7276 10.8131L13.5585 4.96863C13.5578 4.96506 13.5561 4.96173 13.5536 4.95911C13.5511 4.95649 13.5478 4.95464 13.5443 4.95378L13.5267 4.94936L3.6181 2.34603L8.07841 6.80634C8.439 6.63153 8.84373 6.53351 9.27135 6.53351C10.7836 6.53351 12.0095 7.75942 12.0095 9.27165C12.0095 10.7839 10.7836 12.0098 9.27135 12.0098C7.75911 12.0098 6.5332 10.7839 6.5332 9.27165C6.5332 8.84425 6.63113 8.43972 6.80576 8.07928L2.34588 3.6194L4.94897 13.5271L4.9534 13.5447C4.95425 13.5482 4.9561 13.5514 4.95872 13.554C4.96134 13.5565 4.96463 13.5582 4.9682 13.5589L10.8127 14.728L14.7276 10.8131ZM8.3332 9.27165C8.3332 8.75353 8.75323 8.33351 9.27135 8.33351C9.78947 8.33351 10.2095 8.75353 10.2095 9.27165C10.2095 9.78978 9.78947 10.2098 9.27135 10.2098C8.75323 10.2098 8.3332 9.78978 8.3332 9.27165Z", fill: "#676F7E" }) });
var pen_default = SvgPen;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconPen.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconPen = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(pen_default, {}) });
};
IconPen.displayName = "IconPen";
var IconPen_default = IconPen;
